import { Metadata } from './metadata';
import * as v from 'valibot';
export var AssetSchema;
(function (AssetSchema) {
    AssetSchema.Asset = v.object({
        id: v.number(),
        url: v.string(),
        fileName: v.string(),
        contentType: v.string(),
        createdAt: v.string()
    });
    AssetSchema.Form = v.object({
        prefix: v.string(),
        files: v.pipe(v.array(v.object({
            file: v.file(),
            extension: v.string(),
            fileName: v.pipe(v.string(), v.nonEmpty())
        })), v.minLength(1))
    });
    AssetSchema.ListResponse = v.object({
        assets: v.array(AssetSchema.Asset),
        metadata: v.union([Metadata, v.record(v.string(), v.any())])
    });
    AssetSchema.FormResponse = v.object({
        assets: v.array(AssetSchema.Asset)
    });
    AssetSchema.Filters = v.object({
        filename: v.optional(v.string()),
        content_type: v.optional(v.string()),
        sort: v.optional(v.union([
            v.literal('created_at'),
            v.literal('-created_at'),
            v.literal('file_name'),
            v.literal('-file_name')
        ]))
    });
})(AssetSchema || (AssetSchema = {}));
